/** A CSS cursor value for an SVG image with its hotspot. */
const svgCursor = (svg: string, x: number, y: number) =>
	`url("data:image/svg+xml,${encodeURIComponent(svg)}") ${x} ${y}, pointer`;

const selectCursorSvg = (badgeStart: string, badgeEnd: string, symbolPath: string) => `
<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
	<defs>
		<filter id="badgeShadow" x="12" y="12" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
			<feDropShadow dx="0" dy="1" stdDeviation=".5" flood-color="#000" flood-opacity=".25"/>
		</filter>
		<filter id="pointerShadow" x="4" y="5" width="14" height="14" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
			<feDropShadow dx="0" dy="1" stdDeviation=".5" flood-color="#000" flood-opacity=".25"/>
		</filter>
		<linearGradient id="badgeGradient" x1="20.5" y1="13" x2="20.5" y2="28" gradientUnits="userSpaceOnUse">
			<stop stop-color="${badgeStart}"/>
			<stop offset="1" stop-color="${badgeEnd}"/>
		</linearGradient>
	</defs>
	<circle cx="20.5" cy="20.5" r="7.5" fill="url(#badgeGradient)" filter="url(#badgeShadow)"/>
	${symbolPath}
	<path d="M5.183 6.881C4.849 5.837 5.837 4.849 6.881 5.183L15.41 7.797C16.664 8.238 16.649 9.962 15.427 10.37L11.511 11.511L10.37 15.427C9.962 16.649 8.238 16.664 7.81 15.448L5.182 6.882L5.183 6.881ZM6.589 6.138C6.31 6.04 6.04 6.31 6.138 6.589L8.754 15.116C8.865 15.433 9.315 15.43 9.421 15.111L10.706 10.706L15.111 9.421C15.43 9.315 15.433 8.865 15.116 8.754L6.589 6.138Z" fill="#fff" filter="url(#pointerShadow)"/>
	<path d="M6.589 6.138C6.31 6.04 6.04 6.31 6.138 6.589L8.754 15.116C8.865 15.433 9.315 15.43 9.421 15.111L10.706 10.706L15.111 9.421C15.43 9.315 15.433 8.865 15.116 8.754L6.589 6.138Z" fill="#000"/>
	<path opacity=".25" d="M20.5 13C24.642 13 28 16.358 28 20.5C28 20.668 27.992 20.835 27.981 21C27.724 17.091 24.474 14 20.5 14C16.526 14 13.276 17.091 13.019 21C13.008 20.835 13 20.668 13 20.5C13 16.358 16.358 13 20.5 13Z" fill="#fff"/>
</svg>`;

const selectAddCursor = svgCursor(
	selectCursorSvg(
		'#38BDF8',
		'#2563EB',
		'<path d="M20.5 17.5V23.5M23.5 20.5H17.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
	),
	5,
	6
);

const selectRemoveCursor = svgCursor(
	selectCursorSvg(
		'#38BDF8',
		'#2563EB',
		'<path d="M23.5 20.5H17.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
	),
	5,
	6
);

/**
 * Standard cursor values used across the canvas. The select cursors are SVG
 * data URLs, built once at load time from the badge artwork above.
 */
export const Cursor = {
	DEFAULT: 'default',
	GRAB: 'grab',
	GRABBING: 'grabbing',
	POINTER: 'pointer',
	MOVE: 'move',
	NOT_ALLOWED: 'not-allowed',
	CROSSHAIR: 'crosshair',
	COPY: 'copy',
	SELECT_ADD: selectAddCursor,
	SELECT_REMOVE: selectRemoveCursor,
	NONE: 'none',
} as const;
